<template>
  <v-navigation-drawer id="default-drawer" class="drawer" v-model="drawer" :right="$vuetify.rtl"
    :src="drawerImage ? image : ''" :mini-variant="mini" mini-variant-width="80" app width="260"
    :expand-on-hover="false"
  >
    <div class="px-2">
      <default-drawer-header/>

      <v-divider class="mx-3" />

      <!-- <default-account-settings /> -->

      <v-divider class="mx-3 mb-2" />

      <default-list :items="mainTabs" :mini="mini" />
    </div>

    <!-- <template #append>
      <div class="pa-4 text-center">
        <app-btn class="text-none mb-4" href="https://vuetifyjs.com" small text>
          Documentation
        </app-btn>
      </div>
    </template> -->

    <div class="pt-12" />
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'DefaultDrawer',

    components: {
      // DefaultAccountSettings: () => import(
      //   /* webpackChunkName: "default-account-settings" */
      //   './widgets/AccountSettings'
      // ),
      DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
    },

    computed: {
      ...get('user', [
        'dark',
        'gradient',
        'image',
        'mainTabs'
      ]),
      ...get('app', [
        'items',
        'version',
      ]),
      drawer: sync('app/drawer'),
      drawerImage: sync('app/drawerImage'),
      mini: sync('user/drawer@mini'),
      // ...sync('user' [
      //   'mainTabs'
      // ])
    },

    data() {
      return {
      }
    },

    watch: {
      mini() {
        // Zapisz stan w localStorage
        this.$store.dispatch('user/update')
      }
    },

  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
